export class Album {
  title = "";

  description = "";

  photos = [];
}

export class Photo {
  title = "";

  imageUrl = "";
  thumbnailUrl = "";
}

export class Testimonial {
  extract = "";

  content = "";
}

export default class Store {
  photos = [];

  albums = [];

  testimonials = [];

  constructor (data) {
    for (const item of data.albums) {
      const album = new Album();
      album.title = item.title;
      album.description = item.description;
      item.photos.forEach(item => {
        const photo = new Photo();
        photo.title = item.title;
        photo.imageUrl = item.imageUrl;
        photo.thumbnailUrl = item.thumbnailUrl;
        album.photos.push(photo);
        this.photos.push(photo);
      });
      this.albums.push(album);
    }

    for (const item of data.testimonials) {
      const testimonial = new Testimonial();
      testimonial.extract = item.extract;
      testimonial.content = item.content;
      this.testimonials.push(testimonial);
    }
  }
}



/** WEBPACK FOOTER **
 ** ./src/Store.js
 **/